import { clsx } from 'clsx'

import { Avatar } from '@buffer-mono/popcorn'

import styles from './CircleAvatar.module.css'

import type { JSX } from 'react'

type CircleAvatarSize = 'xsmall' | 'small' | 'mid' | 'medium' | 'large'

type CircleAvatarProps = {
  src: string
  alt: string
  size: CircleAvatarSize
  className?: string
}

export const CircleAvatar = ({
  src,
  alt,
  size,
  className,
}: CircleAvatarProps): JSX.Element => (
  <span className={clsx(styles.circleAvatar, className)}>
    <Avatar src={src} alt={alt} size={size} />
  </span>
)

export default CircleAvatar

export type { CircleAvatarProps, CircleAvatarSize }
